module.exports = __webpack_public_path__ + "img/icon-clue-sml.a38d714b.svg";